import { render, staticRenderFns } from "./ContentCardList.vue?vue&type=template&id=edcb1614&scoped=true&"
import script from "./ContentCardList.vue?vue&type=script&lang=js&"
export * from "./ContentCardList.vue?vue&type=script&lang=js&"
import style0 from "./ContentCardList.vue?vue&type=style&index=0&id=edcb1614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcb1614",
  null
  
)

export default component.exports